import { useContext, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f7fb',
    ...theme.typography.body2,

    borderRadius: theme.shape.borderRadius * 1.5,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4.5),
    },
    //
    textAlign: "left",
    color: theme.palette.text.primary,
}));

export const PaywallBlock = (data) =>
{

const { t } = useTranslation();
return (
<Item sx={{ position: "relative" }}>
  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
    <WorkspacePremiumIcon
      sx={{
        mr: 1.5,
        fontSize: 40,
        color: 'error.main',
        mt: '2px'
      }}
    />
    <Typography variant="body1" gutterBottom>
      {t("Приобретите")}{" "}
      <Link to="/cabinet/subscriptions">{t("Премиум подписку")}</Link>{t(", чтобы получить доступ ко всему содержимому")}.
    </Typography>
  </Box>
</Item>
)
}

export const PaywallStep = (data) =>
{

const { t } = useTranslation();
return (
  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
    <WorkspacePremiumIcon
      sx={{
        mr: 1.5,
        fontSize: 40,
        color: 'error.main',
        mt: '2px'
      }}
    />
    <Typography variant="body1" gutterBottom>
      {t("Приобретите")}{" "}
      <Link to="/cabinet/subscriptions">{t("Премиум подписку")}</Link>{t(", чтобы получить доступ ко всему содержимому")}.
    </Typography>
  </Box>
)
}

export const ExpireBlock = (data) =>
{

const { t } = useTranslation();
return (
<Item sx={{ position: "relative" }}>
  <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
    <WorkspacePremiumIcon
      sx={{
        mr: 1.5,
        fontSize: 40,
        color: 'error.main',
        mt: '2px'
      }}
    />
    <Typography variant="body1" gutterBottom>
      {t('Ваша подписка истекла и эти результаты расчёта больше не обновляются')}.
	<br/>
      {t("Приобретите")} <Link to="/cabinet/subscriptions">{t("Премиум подписку")}</Link> {t("снова, чтобы возобновить выполнение расчёта")}.
    </Typography>
  </Box>
</Item>
)
}
